var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    { attrs: { trigger: "click", placement: "bottomRight" } },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loadding } },
            [
              _c(
                "a-tabs",
                [
                  _c("a-tab-pane", { key: "1", attrs: { tab: "通知" } }, [
                    _vm._v("\n          通知\n        ")
                  ]),
                  _vm._v(" "),
                  _c("a-tab-pane", { key: "2", attrs: { tab: "消息" } }, [
                    _vm._v("\n          123\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-tab-pane",
                    { key: "3", attrs: { tab: "待办" } },
                    [
                      _c(
                        "a-list",
                        [
                          _c(
                            "a-list-item",
                            [
                              _c(
                                "a-list-item-meta",
                                {
                                  attrs: {
                                    title: "新项目审核任务待处理",
                                    description: "两小时前"
                                  }
                                },
                                [
                                  _c("a-avatar", {
                                    staticStyle: {
                                      "background-color": "white"
                                    },
                                    attrs: {
                                      slot: "avatar",
                                      src:
                                        "https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png"
                                    },
                                    slot: "avatar"
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "header-notice", on: { click: _vm.fetchNotice } },
        [
          _c(
            "a-badge",
            { attrs: { count: _vm.noticeCount } },
            [
              _c("a-icon", {
                class: ["header-notice-icon", _vm.theme],
                attrs: { type: "bell" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15c948f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c948f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/HeaderNotice.vue
// module id = null
// module chunks = 